import { Button, Modal, ThemeTypeList } from "task-eva-ui";
import {
  AuthenticateModalTitle,
  AuthenticateModalWrapper,
  ModalWrapper,
  AuthenticateModalTip,
  CoupnTip,
  AuthenticateContent,
  AuthenticateItem,
  Line,
  AuthStatusWrapper,
} from "./atom";
import IconSvg from "./svg/icon.svg";
import Enterprise from "./svg/enterprise.svg";
import AlipaySvg from "./svg/alipay.svg";
import AuthStatusSuccess from "./svg/auth-status-success.svg";
import AuthStatusFail from "./svg/auth-status-fail.svg";
import AuthStatusWaiting from "./svg/auth-status-waiting.svg";
import QRCode from "qrcode.react";
import { IUserInfo } from "../user-profile";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { AuthStatus } from "project-config/constants";

export function AuthenticateModalContent({
  changeModal,
  showAuthenticateModal,
  userInfo,
  authenticateLink,
  redirectToAuth,
  redirectToEnterprise,
  authStatus,
}: {
  changeModal: () => void;
  showAuthenticateModal: boolean;
  userInfo?: IUserInfo;
  authenticateLink: string;
  redirectToAuth: () => void;
  redirectToEnterprise: () => void;
  authStatus: AuthStatus;
}) {
  const { t } = useTranslation("common");
  const [isReCertification, setIsReCertification] = useState(false);
  const [authModalInfo, setAuthModalInfo] = useState<any>();
  const authStatusList = [
    AuthStatus.Checking,
    AuthStatus.Passed,
    AuthStatus.Failure,
    AuthStatus.WaitForCheck,
    AuthStatus.Refused,
  ];
  const failStatusList = [AuthStatus.Refused, AuthStatus.Failure];

  const commonAuthStatus = {
    successful: {
      icon: AuthStatusSuccess,
      title: t("authenticate_status_successful"),
      message: t("authenticate_message_successful", {
        value: userInfo?.authGiveAway,
      }),
      buttonText: t("common_sure"),
    },
    checking: {
      icon: AuthStatusWaiting,
      title: t("authenticate_status_waiting"),
      message: t("authenticate_message_waiting"),
      buttonText: t("common_sure"),
    },
    failure: {
      icon: AuthStatusFail,
      title: t("authenticate_status_fail"),
      message: t("authenticate_message_fail"),
      buttonText: t("authenticate_recertification"),
    },
  };

  const modalMap = new Map([
    [AuthStatus.Checking, { ...commonAuthStatus.checking }],
    [AuthStatus.Passed, { ...commonAuthStatus.successful }],
    [AuthStatus.Failure, { ...commonAuthStatus.failure }],
    [AuthStatus.WaitForCheck, { ...commonAuthStatus.checking }],
    [AuthStatus.Refused, { ...commonAuthStatus.failure }],
  ]);

  const handleSure = () => {
    if (failStatusList.includes(authStatus)) {
      setIsReCertification(true);
    } else {
      changeModal();
    }
  };

  useEffect(() => {
    if (authStatusList.includes(authStatus)) {
      setAuthModalInfo(modalMap.get(authStatus));
      setIsReCertification(false);
    }
  }, [authStatus]);

  return (
    <ModalWrapper>
      <Modal
        open={showAuthenticateModal}
        onClose={() => changeModal()}
        closeOnClickOutside={false}
        render={
          authStatus === AuthStatus.Uncertified ||
          (failStatusList.includes(authStatus) && isReCertification) ? (
            <AuthenticateModalWrapper>
              <AuthenticateModalTitle>
                <p>{t("authenticate_title")}</p>
                <AuthenticateModalTip>
                  {t("authenticate_sub_title")}
                </AuthenticateModalTip>
              </AuthenticateModalTitle>
              <CoupnTip>
                <img src={IconSvg} alt="" className="icon" />
                <div>
                  {t("authenticate_text_pre")}{" "}
                  <span>
                    {userInfo?.authGiveAway}
                    {t("authenticate_text_unit")}
                  </span>{" "}
                  {t("authenticate_text_suf")}
                </div>
              </CoupnTip>
              <AuthenticateContent>
                <AuthenticateItem>
                  <span className="title">
                    {t("authenticate_personal_certification")}
                  </span>
                  <div>
                    {authenticateLink && (
                      <QRCode
                        size={138}
                        value={authenticateLink}
                        style={{ borderRadius: "2px" }}
                      />
                    )}
                  </div>
                  <span className="tips">
                    <img src={AlipaySvg} alt="" />
                    {t("authenticate_alipay_text")}
                  </span>
                </AuthenticateItem>
                <Line />
                <AuthenticateItem
                  className="enterprise"
                  onClick={() => redirectToEnterprise()}
                >
                  <span className="title">
                    {t("authenticate_enterprise_certification")}
                  </span>
                  <div>
                    <img src={Enterprise} alt="" />
                    <span>{t("authenticate_business_license")}</span>
                    <span>{t("authenticate_business_public")}</span>
                  </div>
                  <span className="tips">
                    {t("authenticate_go_certification")}{" "}
                  </span>
                </AuthenticateItem>
              </AuthenticateContent>
              <p className="more-text" onClick={() => redirectToAuth()}>
                {t("authenticate_more_certification")}
              </p>
            </AuthenticateModalWrapper>
          ) : (
            <AuthStatusWrapper>
              <img src={authModalInfo?.icon} alt="" />
              <p className="title">{authModalInfo?.title}</p>
              <p className="message">{authModalInfo?.message}</p>
              <Button
                themeType={ThemeTypeList.USER_CENTER}
                onClick={handleSure}
              >
                {authModalInfo?.buttonText}
              </Button>
            </AuthStatusWrapper>
          )
        }
      />
    </ModalWrapper>
  );
}
